import TaskStatusEnum from "@/enum/TaskStatus";
import { autoMergeMergerableOrders, AutoMergeMergerableOrderScene, getAutoMergerResult } from "@/services/api/order";
import delay from "@/utils/delay";
import { useRequest } from "ahooks";
import { Checkbox, Modal, ModalFuncProps } from "antd";
import React, { useRef } from "react";

const useImmediateMergeOrderOnEnable = (shopId: number, onSuccess: () => void) => {
    const stopRef = useRef(false);

    const handleMergeOrders = async (autoMergeManualIndependentOrder?: boolean) => {
        const { taskId } = await autoMergeMergerableOrders({
            shopId,
            autoMergeManualIndependentOrder,
            scene: AutoMergeMergerableOrderScene.ENABLE_AUTO_MERGE_SETTING,
        });

        stopRef.current = false;

        while (true) {
            if (stopRef.current) {
                return;
            }

            const result = await getAutoMergerResult(shopId, taskId);
            const status = result?.taskStatus;

            if ([TaskStatusEnum.PENDING, TaskStatusEnum.RUNNING].includes(status)) {
                await delay(1200);
                continue;
            }

            if (status === TaskStatusEnum.COMPLETED) {
                Modal.success({
                    title: "当前待发货订单合并成功",
                    keyboard: false,
                    onOk: () => onSuccess?.(),
                });

                break;
            }
            if (status === TaskStatusEnum.ERROR) {
                Modal.error({ title: `合并失败,请联系客服反馈:${result.error}` });

                return;
            }
        }
    };

    const showMergeConfirmation = async () => {
        let autoMergeManualIndependentOrder: boolean;

        const modalConfig: ModalFuncProps = {
            width: 510,
            title: <span className="fb">保存自动合并成功，是否对当前符合条件待发货订单生效?</span>,
            content: (
                <div>
                    <div style={{ marginBottom: 8 }}>
                        <Checkbox defaultChecked disabled>
                            符合自动合并规则的订单
                        </Checkbox>
                        <a
                            href="https://qw15p3s8hv.feishu.cn/wiki/XThfwZTWtiJVUukux4WcKYeOnKe"
                            target="_blank"
                            className="ml5"
                        >
                            查看自动合并订单的详细规则
                        </a>
                    </div>
                    <Checkbox
                        onChange={(e) => {
                            autoMergeManualIndependentOrder = e.target.checked;
                        }}
                    >
                        手动取消合并且满足其他自动合并规则<span className="text-gray">（如未打印、同买家地址等）</span>
                        的订单
                    </Checkbox>
                </div>
            ),
            okCancel: true,
            onCancel: () => {
                stopRef.current = true;
            },
            okText: "确认合并",
            onOk: () => handleMergeOrders(autoMergeManualIndependentOrder),
        };

        Modal.warning(modalConfig);
    };

    const { runAsync: handleImmediateMergeOrderOnEnable } = useRequest(showMergeConfirmation, { manual: true });

    return { handleImmediateMergeOrderOnEnable };
};

export default useImmediateMergeOrderOnEnable;
